import React, { useState } from "react";
import ProfileCard from "pages/Profile/components/ProfileCard";
import ProfileButton from "pages/Profile/components/ProfileButton";
import cx from "classnames";

const CreditEntry = ({ title, type, role, company, year, director }) => (
  <div className="border-b border-white/20 last:border-0">
    <h3 className="mb-1.5 text-s font-semibold uppercase dark:text-white">
      {title}
    </h3>
    <div className="grid grid-cols-2 justify-items-start gap-y-1 pb-3 text-s">
      <div>
        <span className="dark:text-white/50">Type:</span>{" "}
        <span className="dark:text-white/70">{type}</span>
      </div>
      <div>
        <span className="dark:text-white/50">Year:</span>{" "}
        <span className="dark:text-white/70">{year}</span>
      </div>
      <div>
        <span className="dark:text-white/50">Role:</span>{" "}
        <span className="dark:text-white/70">{role}</span>
      </div>
      <div>
        <span className="dark:text-white/50">Director:</span>{" "}
        <span className="dark:text-white/70">{director}</span>
      </div>
      <div>
        <span className="dark:text-white/50">Company:</span>{" "}
        <span className="dark:text-white/70">{company}</span>
      </div>
    </div>
  </div>
);

interface Props {
  isEdit?: boolean;
}

const CreditsCard = ({ isEdit }: Props) => {
  const [activeTab, setActiveTab] = useState("FEATURE FILM");
  const tabs = ["FEATURE FILM", "COMMERCIALS", "THEATRE", "VERTICAL SHORT"];

  const credits = [
    {
      title: "The Awakening",
      type: "Feature Film",
      role: "Supporting - Claire",
      company: "A24 Films",
      year: "2023",
      director: "Greta Gerwig",
    },
    {
      title: "Winter's Edge",
      type: "Feature Film",
      role: "Lead - Emma",
      company: "Focus Features",
      year: "2024",
      director: "Sofia Coppola",
    },
    {
      title: "The Last Letter",
      type: "Feature Film",
      role: "Supporting - Rachel",
      company: "Searchlight Pictures",
      year: "2022",
      director: "Yorgos Lanthimos",
    },
    {
      title: "City Lights",
      type: "Feature Film",
      role: "Anna",
      company: "Netflix Films",
      year: "2023",
      director: "Noah Baumbach",
    },
    {
      title: "Beyond the Horizon",
      type: "Feature Film",
      role: "Dr. Sarah Mitchell",
      company: "Warner Bros",
      year: "2021",
      director: "Denis Villeneuve",
    },
  ];

  return (
    <ProfileCard isEdit={isEdit}>
      <h2 className="mb-4 text-m uppercase tracking-wider dark:text-white">
        Credits
      </h2>

      <div className="mb-3 flex gap-1.5 px-1 text-s dark:text-white/70">
        <button className="decoration-white/30 hover:text-white">
          View without tabs
        </button>
        <span className="opacity-30">|</span>
        <button className="decoration-white/30 hover:text-white">
          View in date order
        </button>
      </div>

      {/* Tabs */}
      <div className="mb-4 flex flex-wrap gap-1">
        {tabs.map((tab) => (
          <ProfileButton
            isText
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={cx("font-normal", {
              "!bg-color-brand-one text-white dark:!bg-white dark:text-color-brand-one":
                activeTab === tab,
              "dark:text-white/70": activeTab !== tab,
            })}
          >
            {tab}
          </ProfileButton>
        ))}
      </div>

      {/* Credits List */}
      <div className="space-y-2">
        {credits.map((item, index) => (
          <CreditEntry key={index} {...item} />
        ))}
      </div>

      <div className="mt-4 flex gap-1.5 border-t border-white/20 pt-4 text-sm dark:text-gray-300">
        <button className="hover:text-white">View more</button>
        <span className="opacity-30">|</span>
        <button className="hover:text-white">View all</button>
      </div>
    </ProfileCard>
  );
};

export default CreditsCard;
